import { render, staticRenderFns } from "./ProductTagTranslationEditPopup.vue?vue&type=template&id=906a5ace&"
import script from "./ProductTagTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProductTagTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports